import { Model, belongsTo, hasMany } from 'miragejs'

export default Model.extend({
  school: belongsTo(),
  teachers: hasMany(),
  students: hasMany(),
})
